import { Box } from "@chakra-ui/react"
import React from "react"
import Meta from "../../components/meta/Meta"

export default function TrackSellersApi() {
  return (
    <>
      <Meta
        pageName={"TrackSellers | TrackSellers API"}
        hrefLink={"https://www.tracksellers.com/tracksellers-api"}
      />
      <Box width="100%" height={"800px"} zIndex={999999} marginTop="70px">
        <iframe src="/apidoc/index.html"
          width={"100%"}
          height={"100%"}
          frameBorder="0"
          scrolling="auto"
          id="apiDocFrame"
        ></iframe>
      </Box>
    </>
  )
}